import React, { useEffect, useState } from "react"
import { WBLabel } from "./WBLabel"
import { WBInput } from "./WBInput"
import { Button } from "@material-tailwind/react"
import { currencyFormat } from "../../helper/numberHelper"
import { NumericFormat } from "react-number-format"

function CalculatorKPR ({
    price
}) {

    const [ 
        formCalcKPR,
        setFormCalcKPR
    ] = useState({
        formattedPrice: 'IDR ',
        formattedDP: 'IDR ',
        totalPrice: 0,
        DP: 0,
        DPPercent: 20,
        interestRate: 7,
        years: 15,
        totalCicilan: 0,
        disableAutoCount: false
    })

    useEffect(() => {
        if (price) { onChange({ totalPrice: price, DP: price * 0.2, formattedPrice: currencyFormat(price), formattedDP: currencyFormat(price * 0.2) }) }
    }, [price])

    useEffect(() => {
        if (!formCalcKPR.disableAutoCount && formCalcKPR.totalPrice && formCalcKPR.DP) { 
            calculateKPR()
            onChange({disableAutoCount: true})
        }
    }, [formCalcKPR.totalPrice || formCalcKPR.DP])

    const onChange = (e) => {
        console.log(e)
        setFormCalcKPR(prev => ({
            ...prev,
            ...e
        }))
    }

    const calculateKPR = () => {
        let { 
            totalPrice,
            DP,
            interestRate,
            years
        } = formCalcKPR
        // let pinjaman = totalPrice - DP
        // const cicilanPokok = Math.ceil((pinjaman) / (years * 12))
        // const cicilanBungaPerBulan = Math.ceil((pinjaman * (interestRate/100) * years) / (years * 12))
        // const totalCicilan = Number(cicilanPokok) + Number(cicilanBungaPerBulan)
        // console.log(pinjaman, years * 12, cicilanPokok, cicilanBungaPerBulan, (interestRate/100), (pinjaman * (interestRate/100) * years))

        // calculate monthly payment
        const P = totalPrice - DP;
        const r = ((interestRate.toString().replace(',', '.')) / 100) / 12;
        const n = years * 12;
        console.log(P, r, n)

        const x = Math.pow(1+r, n);
        const numerator = r * x;
        const denominator = x - 1;

        const fraction = numerator / denominator;

        const M = P * fraction;
        // return {monthlyPayment: Math.round(100*M)/100} // round to nearest 100th
        let totalCicilan = Math.round(100*M)/100

        onChange({totalCicilan})
    }

    return (
        <>
            <WBLabel size={18} color="black" bold text={`Simulasi KPR`}/>
            <div className="mt-4 gap-4">
                {/* <WBInput label={"Harga Properti"} value={formCalcKPR.totalPrice} onChange={(e) => {
                    onChange({totalPrice: e.currentTarget.value})
                }} className={"rounded-[18px]"} /> */}
                <WBLabel text={"Harga Properti"}/>
                <NumericFormat value={formCalcKPR.formattedPrice} 
                    isAllowed={(values) => {
                        const {floatValue} = values;
                        return true
                    }}
                    onValueChange={(values) => {
                        const {formattedValue, value, floatValue} = values;
                        let DP = 0
                        let formattedDP = ''
                        if (value) {
                            if (formCalcKPR.DPPercent) {
                                DP = value * (formCalcKPR.DPPercent / 100)
                                if (DP) { formattedDP = currencyFormat(DP) }
                            }
                        }
                        onChange({formattedPrice: formattedValue, totalPrice: value.replace(/^0+/, ''), DP, formattedDP})
                    }}
                    // disabled={form._id}
                    decimalScale={0}
                    allowLeadingZeros={false}
                    allowedDecimalSeparators={false}
                    allowNegative={false}
                    thousandSeparator
                    customInput={WBInput}
                    prefix={"IDR "}
                />
                <div className="mt-2"/>
                <WBLabel text={"Uang Muka"}/>
                <NumericFormat value={formCalcKPR.formattedDP} 
                    isAllowed={(values) => {
                        const {floatValue} = values;
                        return true
                    }}
                    onValueChange={(values) => {
                        const {formattedValue, value, floatValue} = values;
                        let DPPercent = 0
                        if (value) {
                            if (formCalcKPR.totalPrice) { 
                                DPPercent = Math.round((value / formCalcKPR.totalPrice) * 100)
                            }
                        }
                        onChange({formattedDP: formattedValue, DP: value.replace(/^0+/, ''), DPPercent})
                    }}
                    // disabled={form._id}
                    decimalScale={0}
                    allowLeadingZeros={false}
                    allowedDecimalSeparators={false}
                    allowNegative={false}
                    thousandSeparator
                    customInput={WBInput}
                    prefix={"IDR "}
                />
                <div className="relative flex justify-center text-right mt-1">
                    <WBInput value={formCalcKPR.DPPercent} onChange={(e) => {
                        var pattern = /^\d+\.?\d*$/;
                        let isNumber = pattern.test(e.currentTarget.value);  // returns a boolean
                        if (!isNumber && e.currentTarget.value) { return; }
                        let DP = 0
                        let formattedDP = ""
                        if (e.currentTarget.value) { 
                            if (formCalcKPR.totalPrice) {
                                DP = formCalcKPR.totalPrice * (e.currentTarget.value / 100)
                                if (DP) { formattedDP = currencyFormat(DP) }
                            }
                        }
                        onChange({DPPercent: e.currentTarget.value, DP, formattedDP})
                    }} className={"w-20 rounded-[18px]"} />
                    <WBLabel text={"%"} className={"!absolute right-4 top-2"}/>
                </div>
                <div className="mt-2"/>
                <WBLabel text={"Bunga"}/>
                <div className="relative flex w-full justify-center">
                    <WBInput value={formCalcKPR.interestRate} onChange={(e) => {
                        var pattern = /^\d+\.?\d*$/;
                        let isNumber = pattern.test(e.currentTarget.value);  // returns a boolean
                        if (!isNumber && e.currentTarget.value) { return; }
                        onChange({interestRate: e.currentTarget.value})
                    }} className={"rounded-[18px]"} />
                    <WBLabel text={"per tahun"} className={"!absolute right-4 top-2"}/>
                </div>
                <div className="mt-2"/>
                <WBLabel text={"Jangka Cicilan"}/>
                <div className="relative flex w-full justify-center">
                    <WBInput label={""} value={formCalcKPR.years} onChange={(e) => {
                        var pattern = /^\d+\.?\d*$/;
                        let isNumber = pattern.test(e.currentTarget.value);  // returns a boolean
                        if (!isNumber && e.currentTarget.value) { return; }
                        onChange({years: e.currentTarget.value})
                    }} className={"rounded-[18px]"} />
                    <WBLabel text={"tahun"} className={"!absolute right-4 top-2"}/>
                </div>
                <div className="flex mt-8 mb-4">
                    <div className="w-[50%] align-center">
                        <WBLabel size={12} text={"Jumlah Pinjaman"}/>
                    </div>
                    <div className="w-[50%] text-right">
                        <WBLabel size={16} bold text={currencyFormat((formCalcKPR.totalPrice - formCalcKPR.DP))}/>
                    </div>
                </div>
                <div className="flex mt-4 mb-4">
                    <div className="w-[50%] align-center">
                        <WBLabel size={12} text={"Cicilan Perbulan"}/>
                    </div>
                    <div className="w-[50%] text-right font-bold">
                        <WBLabel size={16} bold text={currencyFormat(formCalcKPR.totalCicilan)}/>
                    </div>
                </div>
                <div className="w-[100%] mt-8">
                    <Button className="w-[100%] bg-gold" onClick={() => {calculateKPR()}}>Hitung</Button>
                </div>
            </div>
        </>
    )
}

export default CalculatorKPR